import React from "react";
import { useNavigate } from "react-router-dom";
import { Globe, LogOut, Info, Headphones, ChevronLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useT } from "../i18n/LanguageContext";
import { useAppVersion } from "../lib/useAppVersion";
import { PageHeader } from "../components/PageHeader";

export default function Settings() {
  const { logout } = useAuth();
  const { lang, setLang } = useT();
  const version = useAppVersion();
  const navigate = useNavigate();
  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="الإعدادات" />
      <div className="bg-white rounded-2xl border border-[#E8EAF2] p-5">
        <div className="flex items-center gap-3 mb-4">
          <Globe size={20} className="text-[#FF3D5A]" /><span className="font-black flex-1">اللغة</span>
        </div>
        <div className="flex gap-2">
          <button data-testid="lang-ar" onClick={() => setLang("ar")} className={`flex-1 py-3 rounded-xl font-black ${lang === "ar" ? "bg-[#FF3D5A] text-white" : "bg-[#F0F2FA]"}`}>العربية</button>
          <button data-testid="lang-en" onClick={() => setLang("en")} className={`flex-1 py-3 rounded-xl font-black ${lang === "en" ? "bg-[#FF3D5A] text-white" : "bg-[#F0F2FA]"}`}>English</button>
        </div>
      </div>
      <button data-testid="settings-help" onClick={() => navigate("/help")} className="w-full flex items-center gap-3 bg-white rounded-2xl border border-[#E8EAF2] p-5 mt-4 text-right">
        <Headphones size={20} className="text-[#FF3D5A]" />
        <span className="font-black flex-1">المساعدة والدعم</span>
        <ChevronLeft size={20} className="text-[#9CA3AF]" />
      </button>
      <div className="bg-white rounded-2xl border border-[#E8EAF2] p-5 mt-4 flex items-center gap-3 text-[#6B7280]"><Info size={20} /> نطاق للتسوق • الإصدار {version}</div>
      <button data-testid="settings-logout" onClick={async () => { if (window.confirm("تسجيل الخروج؟")) { await logout(); navigate("/login"); } }} className="w-full flex items-center justify-center gap-2 py-4 rounded-2xl bg-[#FFE5EA] text-[#FF3D5A] font-black mt-4"><LogOut size={20} /> تسجيل الخروج</button>
    </div>
  );
}
